import AuthService from '../services/auth.service';
import Vue from 'vue'

const user = JSON.parse(localStorage.getItem('user'));
const premiumChannel = JSON.parse(localStorage.getItem('premiumChannel'));
const pagesEnabled = JSON.parse(localStorage.getItem('pagesEnabled'));
const initialState = user
    ? { status: { loggedIn: true }, user, premiumChannel, pagesEnabled }
    : { status: { loggedIn: false }, user: null, premiumChannel: null, pagesEnabled: null};

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        websiteLogin({ commit }, info) {
            return AuthService.websiteLogin(info.dbid, info.token).then(
                response => {
                    commit('loginSuccess', response);
                    return Promise.resolve(response);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        login({ commit }, info) {
            return AuthService.login(info.user, info.channelId, info.token).then(
                response => {
                    commit('loginSuccess', response);
                    return Promise.resolve(response);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit }) {
            AuthService.logout();
            commit('logout');
        },
        forbidden({ commit }, message) {
            AuthService.logout();
            commit('forbidden', message);
        },
        getClients() {
            return AuthService.getClients().then(
                clients => {
                    return Promise.resolve(clients);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        sentToken({ commit }, info) {
            return AuthService.sentToken(info.user, info.channelId).then(
                () => {
                    return Promise.resolve();
                },
                error => {
                    commit('');
                    return Promise.reject(error);
                }
            );
        }
    },
    mutations: {
        loginSuccess(state, response) {
            state.status.loggedIn = true;
            state.user = response.user;
            state.premiumChannel = response.premiumChannel;
            state.pagesEnabled = response.pagesEnabled;

            Vue.swal.fire({
                title: 'Zalogowano pomyślnie!',
                icon: 'success',
                timer: 1000,
                showConfirmButton: false,
            });
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
            state.premiumChannel = null;
            state.pagesEnabled = null;

            Vue.swal.fire({
                title: 'Błąd podczas logowania!',
                icon: 'error',
                timer: 1000,
                showConfirmButton: false,
            });
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;
            state.premiumChannel = null;
            state.pagesEnabled = null;

            Vue.swal.fire({
                title: 'Wylogowano pomyślnie!',
                icon: 'success',
                timer: 1000,
                showConfirmButton: false,
            });
        },
        forbidden(state, message = null) {
            state.status.loggedIn = false;
            state.user = null;
            state.premiumChannel = null;
            state.pagesEnabled = null;

            Vue.swal.fire({
                title: 'Wylogowywanie!',
                text: 'Jesteś offline lub nie posiadasz kanału Premium. ' + (message ? 'Message: ' + message : ''),
                icon: 'error',
                timer: 2000,
                showConfirmButton: false,
            });
        },
    }
};